import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Modal, } from "react-bootstrap";
import { Button } from "../../components";
import { FormCheck, FormInput, FormLabel } from "../../components/forms";
import { BooleanSelect, GenericAdviserSelect, GenericUserDivisionSelect, MasterAccountStatusSelect, MasterAccountTypeSelect, ServiceAgreementsSelect } from "../../components/forms/selects";
import { useFilterContext } from "../../hooks/FilterContext";
import ThemedModal from "../../components/utilities/ThemedModal";
import VulnerabilityTypesSelect from "../../components/forms/selects/VulnerabilityTypeSelect";

export const ClientManagementFiltersModal = ({
    handleClose, onFiltersChanged, show, ...rest
}) => {
    const { defaultFilters, filter, setFilter } = useFilterContext();
    const [tempFilters, setTempFilters] = useState(filter);

    const onApplyFilters = () => {
        setFilter((original) => ({
            ...original,
            ...tempFilters,
        }));
        onClose();
    };

    const onClearFilters = () => {
        setTempFilters(defaultFilters);
    };

    const onFilterValueChanged = (property, value) => {
        setTempFilters((original) => {
            return {
                ...original,
                [property]: value,
            };
        });
    };

    const onClose = () => {
        if (handleClose && typeof handleClose === "function") {
            handleClose();
        }
    };

    useEffect(() => {
        setTempFilters(oldTemp => !_.isEqual(oldTemp, filter)
            ? filter
            : oldTemp
        );
    }, [filter]);

    return <Modal size="lg" centered backdrop="static" show={show} onHide={handleClose}>
        <ThemedModal.Header closeButton>
            <Modal.Title>Client Management Filters</Modal.Title>
        </ThemedModal.Header>
        <Modal.Body {...rest}>
            <ClientManagementFilters
                filter={tempFilters}
                setFilter={onFilterValueChanged} />
        </Modal.Body>
        <Modal.Footer>
            <Button variant="warning" onClick={onClearFilters}>
                Clear Filters
            </Button>
            <Button variant="success" onClick={onApplyFilters}>
                Apply Filters
            </Button>
            <Button variant="light" onClick={onClose}>
                Cancel
            </Button>
        </Modal.Footer>
    </Modal>;
};

export const ClientManagementFilters = ({ filter, setFilter }) => {

    const {
        accountTypes,
        accountStatuses,
        serviceLevelAgreementIds,
        divisionIds,
        adviserIds,
        reviewAdviserIds,
        hideUnfavourited,
        surname,
        isVulnerable,
        vulnerabilityTypeIds,
        accompaniedMeetingsDiscussed,
        specialStepsRequired,
    } = filter;

    return <>
        <div className="row gy-2">
            <div className="col-6">
                <FormInput
                    label="Client Surname"
                    value={surname}
                    onChange={(e) => setFilter("surname", e.target.value)}
                    disableAnimations
                />
            </div>
            <div className="col-6">
                <FormCheck
                    groupClassName="mt-4 ps-1"
                    label="Only show favourited clients"
                    labelFirst
                    isChecked={hideUnfavourited}
                    onChange={(check) => setFilter("hideUnfavourited", check)}
                    disableAnimations
                />
            </div>
            <div className="col-6">
                <MasterAccountTypeSelect
                    label="Account Type"
                    defaultValue={accountTypes}
                    onChange={(selections) => setFilter("accountTypes", selections.map(v => v.value))}
                    disableAnimations
                    isMulti
                />
            </div>
            <div className="col-6">
                <GenericUserDivisionSelect
                    label="Division"
                    defaultValue={divisionIds}
                    onChange={(selections) => setFilter("divisionIds", selections.map(v => v.value))}
                    disableAnimations
                    isMulti
                />
            </div>
            <div className="col-6">
                <MasterAccountStatusSelect
                    label="Account Status"
                    defaultValue={accountStatuses}
                    onChange={(selections) => setFilter("accountStatuses", selections.map(v => v.value))}
                    disableAnimations
                    isMulti
                />
            </div>
            <div className="col-6">
                <ServiceAgreementsSelect
                    label="Service Level"
                    defaultValue={serviceLevelAgreementIds}
                    onChange={(selections) => setFilter("serviceLevelAgreementIds", selections.map(v => v.value))}
                    disableAnimations
                    isMulti
                />
            </div>
            <div className="col-6">
                <GenericAdviserSelect
                    label="Adviser"
                    defaultValue={adviserIds}
                    onChange={(selections) => setFilter("adviserIds", selections.map(v => v.value))}
                    disableAnimations
                    isMulti
                />
            </div>
            <div className="col-6">
                <GenericAdviserSelect
                    label="Review Adviser"
                    defaultValue={reviewAdviserIds}
                    onChange={(selections) => setFilter("reviewAdviserIds", selections.map(v => v.value))}
                    disableAnimations
                    isMulti
                />
            </div>
            <div className="col-6">
                <BooleanSelect
                    label="Show vulnerable clients"
                    defaultValue={isVulnerable}
                    onChange={(selection) => setFilter("isVulnerable", selection ? selection.value : null)}
                    isClearable
                />
            </div>
            <div className="col-6">
                <VulnerabilityTypesSelect
                    label="Vulnerability Type"
                    defaultValue={vulnerabilityTypeIds}
                    onChange={(selections) => setFilter("vulnerabilityTypeIds", selections.map(v => v.value))}
                    isMulti
                />
            </div>
            <div className="col-6">
                <FormLabel
                    wrapLabel
                >
                    Have you discussed if the client would like a friend or family member to join meetings?
                </FormLabel>
                <BooleanSelect
                    defaultValue={accompaniedMeetingsDiscussed}
                    onChange={(selection) => setFilter("accompaniedMeetingsDiscussed", selection ? selection.value : null)}
                    isClearable
                />
            </div>
            <div className="col-6">
                <br />
                <FormLabel
                    wrapLabel
                >
                    Are special steps needed to address vulnerabilities?
                </FormLabel>
                <BooleanSelect
                    defaultValue={specialStepsRequired}
                    onChange={(selection) => setFilter("specialStepsRequired", selection ? selection.value : null)}
                    isClearable
                />
            </div>
        </div>
    </>;
};

export default ClientManagementFilters;
